
<template lang="pug">
.section.section-research
  h2.mt-8.mb-2 Laboratory
  .research-content
    .research.shadow-md.p-4.mb-4.rounded-md(v-for="research in researches")
      h2.text-base.font-semibold {{ research.name }}
      p.text-sm {{ research.description }}
      a.btn-block.mt-2(@click="researchTechnology(research.id)" :class="canRetrieve(research.costs) ? 'available' : 'unavailable'") Research {{ research.name }}
      .costs.flex.flex-wrap.justify-end
        p.text-sm.pr-2 Costs:
        .cost.whitespace-no-wrap.mr-4.flex(v-for="(amount, id) in research.costs")
          Resource(:item="id" :amount="amount" :canAfford="canRetrieve({ [id]: amount })")
</template>

<script>

import Resource from '@/components/Resource'

export default {
  name: 'Laboratory',
  props: [ 'researches', 'inventory' ],
  components: { Resource },
  methods: {
    researchTechnology (id) {
      this.$emit('research', id)
    },
    canRetrieve (wants) {
      let contents = this.inventory
      for (let i in wants) {
        if (!contents[i]) {
          return false
        }
        if (contents[i] < wants[i]) {
          return false
        }
      }
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Laboratory.vue